import { compose, combineReducers, createStore, applyMiddleware } from "redux";
import { createEpicMiddleware, combineEpics } from "redux-observable";
import { persistStore } from "redux-persist";
import logger from "redux-logger";

import services from "../services";

import { authReducer } from "./auth/authReducer";
import * as authEpics from "./auth/authEpics";

import { tournamentReducer } from "./tournament/tournamentReducer";
import * as tournamentEpics from "./tournament/tournamentEpics";

import { playerReducer } from "./player/playerReducer";
import * as playerEpics from "./player/playerEpics";

import { shopReducer } from "./shop/shopReducer";
import * as shopEpics from "./shop/shopEpics";

import { articlesReducer } from "./articles/articlesReducer";
import * as articleEpics from "./articles/articlesEpics";

import { userReducer } from "./user/userReducer";
import * as userEpics from "./user/userEpics";

import { dashboardReducer } from "./dashboard/dashboardReducer";
import * as dashboardEpics from "./dashboard/dashboardEpics";

import { instagramReducer } from "./instagram/instagramReducer";
import * as instagramEpics from "./instagram/instagramEpics";

import { youtubeReducer } from "./youtube/youtubeReducer";
import * as youtubeEpics from "./youtube/youtubeEpics";

import { judgeReducer } from "./judge/judgeReducer";
import * as judgeEpics from "./judge/judgeEpics";

import { cardsReducer } from "./cards/cardsReducer";
import * as cardsEpics from "./cards/cardsEpics";

import { pointsReducer } from "./points/pointsReducer";
import * as pointsEpics from "./points/pointsEpics";

import { assetsReducer } from "./assets/assetsReducer";
import * as assetsEpics from "./assets/assetsEpics";

import { contactsReducer } from "./contacts/contactsReducer";
import * as contactsEpics from "./contacts/contactsEpics";

import { rulesReducer } from "./rules/rulesReducer";
import * as rulesEpics from "./rules/rulesEpics";

import { leaderboardReducer } from "./leaderboard/leaderboardReducer";
import * as leaderboardEpics from "./leaderboard/leaderboardEpics";

import { presetsReducer } from "./presets/presetsReducer";
import * as presetsEpics from "./presets/presetsEpics";

import { communityLeaderReducer } from "./community-leader/communityLeaderReducer";
import * as communityLeaderEpics from "./community-leader/communityLeaderEpics";

let composeEnhancers;
if (process.env.NODE_ENV === "production") {
	composeEnhancers = compose;
} else {
	composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

const epicMiddleware = createEpicMiddleware({
	dependencies: services,
});

const rootReducer = combineReducers({
	auth: authReducer,
	player: playerReducer,
	shop: shopReducer,
	tournament: tournamentReducer,
	articles: articlesReducer,
	user: userReducer,
	dashboard: dashboardReducer,
	instagram: instagramReducer,
	youtube: youtubeReducer,
	judge: judgeReducer,
	cards: cardsReducer,
	points: pointsReducer,
	assets: assetsReducer,
	contacts: contactsReducer,
	leaderboard: leaderboardReducer,
	presets: presetsReducer,
	rules: rulesReducer,
	communityLeader: communityLeaderReducer,
});

const rootEpic = combineEpics(
	...Object.values(authEpics),
	...Object.values(tournamentEpics),
	...Object.values(playerEpics),
	...Object.values(shopEpics),
	...Object.values(articleEpics),
	...Object.values(userEpics),
	...Object.values(dashboardEpics),
	...Object.values(instagramEpics),
	...Object.values(youtubeEpics),
	...Object.values(judgeEpics),
	...Object.values(cardsEpics),
	...Object.values(pointsEpics),
	...Object.values(assetsEpics),
	...Object.values(contactsEpics),
	...Object.values(leaderboardEpics),
	...Object.values(presetsEpics),
	...Object.values(rulesEpics),
	...Object.values(communityLeaderEpics)
);

export const store = createStore(
	rootReducer,
	process.env.NODE_ENV === "production"
		? composeEnhancers(applyMiddleware(epicMiddleware))
		: composeEnhancers(applyMiddleware(logger, epicMiddleware))
);

export const persistor = persistStore(store);

epicMiddleware.run(rootEpic);
